<template>
    <div>
        <template v-if="viewPage == true">
            <div class="modal fade" id="batchSummary" tabindex="-1" role="dialog" aria-labelledby="batchSummaryLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <div class="modal-body batchSummary-payment-popup text-left p-4">
                        <div class="popup-head line-head">
                            <h2 class="pb-2"> Summary </h2>
                        </div>
                        <div class="row normal-ib-space mt-3">
                            <div class="col-md-12 mb-3">
                            <table width="100%" v-if="batchSummary != null">
                                <tr>
                                <td> Records inserted </td>
                                <td id="inserted_rows"> {{ inserted }} </td>
                                </tr>
                                <tr>
                                <td> Discrepant records (Invalid Phone No. Or CNIC Or Disabled Campus) </td>
                                <td id="discrepant_rows"> {{ discrepants }} </td>
                                </tr>
                            </table>
                            </div>
                            <div class="col align-right">
                            <button class="btn btn-primary" v-on:click="proceedToShops"> Proceed </button>
                            <button class="btn btn-primary" v-if="discrepantStudents.length > 0" v-on:click="csvExport"> Download Discrepants</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="needAttention" tabindex="-1" aria-labelledby="needAttention" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body fields-map-popup">
                            <div class="popup-head mb-4">
                                <h2 class="pb-0"> Need your attention. </h2>
                                <p> Please, add or map them all. </p>
                            </div>
                            <div class="need-attention-content">
                            </div>
                            <div class="mt-4 text-right">
                                <button type="button" class="btn btn-primary" id="popupProcessButton">Proceed</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="modal fade" id="addCategory" tabindex="-1" aria-labelledby="addCampus" role="dialog" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" aria-label="Close">
                            <span>&times;</span>
                        </button>
                        <div class="modal-body">
                            <div class="popup-head line-head mb-4">
                                <h2 class="pb-3"> Add Campus  </h2>
                            </div>
                            <div class="form-group">
                                <input type="text" class="form-control" id="campusAddValue" />
                            </div>
                            <div class="text-right">
                                <button type="button" @click="saveCampus()" class="btn btn-primary">Save</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div> <!-- Need Ateention Modal End -->
            <div class="clearfix">
                <div class="page-top mb-1 mb-3 align-center clearfix">
                    <h1 class="float-left">  Student/Member Bulk Upload </h1>
                    <div class="progress-bar-holder">
                        <div class="progress step-one">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                        <ul class="prgress-number">
                            <li class="progress-number-list active">
						<span class="bullet">
							1
						</span>
                                <p> Upload </p>
                            </li>
                            <li class="progress-number-list" id="progressNumberListTwo">
						<span class="bullet">
							2
						</span>
                                <p> Field Mapping </p>
                            </li>
                        </ul>
                    </div>
                    <button class="btn btn-primary float-right mr-1" id="process_dropzone_queue" v-show="proceedButtonflag"> Proceed </button>
                    <router-link class="btn btn-primary float-right mr-1" to="/feeStudents"> Cancel </router-link>
                </div>
                <div class="batch-upload-main">
                    <div class="batch-upload-inner">
                        <div class="upload-sheet" v-show="previewMapField == false">
                            <label for="" class="label block-label upload-label"> Upload a CSV <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title=".CSV is an Microsoft Excel file format which is a requirement for Payroll Plus to read your file. You can save your Excel file into a .CSV file using 'save as' option listed under file menu on your Excel program."></i>
                            </label>
                            <p> You can also download a sample template <a :href="`${$global.aws_base_url}/csv/BulkStudentUpload.csv`">here</a>. </p>
                            <form  method="post" class="box dropzone drozone-label dz-clickable dropzone content mt-4" action="/upload" id="drop" data-toggle="tooltip" data-placement="left" title="<p class='align-left'>Your CSV file must have the following in order to upload Vouchers in bulk: <br/>
                            1. No repetitions of column names.<br/>
                            2. Only add correct student / Member IDs.<br/>
                            3. Add Number of Invoices needed against each Student / Member ID <br/>
                            4. No special characters in the sheet.<br/>
                            5. There should be no empty cells in a valid row.<br/>
                            6. Student / Member ID, No. of invoices, Due date of first invoice and Due date interval are required to upload a batch.</p>">

                                <div class="box__input dz-message">
                                    <label class="drozone-label" for="file">
                                        <img  id="uploadIcon" for="file" src="/images/svgs/upload-icon.svg" alt="" class="upload">
                                        <span for="file" class="filename"> Drop your file here </span>
                                    </label>
                                    <label class="uploadedFileName">Drop your file here</label>
                                </div>
                            </form>
                            <em class="dropzone-or"> Or </em> <label id="selectFromComputer" class="btn btn-primary select-file-btn"> Select from your computer </label>
                        </div> <!-- upload sheet -->
                        <div class="previewMapField" v-show="previewMapField == true">
                            <div class="mandatory-fields mb-4">
                                <label for="" class="label block-label upload-label mb-3"> Mandatory Information <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="These fields are required for Payroll Plus to process your sheet."></i> </label>
                                <div class="mandatory-tags">
                                    <div class="mandatory-fields-inner">
                                        <div class="mandatory-field-col"> <span class="map-value" title="Name"> <i v-show="mand_name" class="fas fa-check"></i> Name </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Student/Member ID"> <i v-show="mand_studentid" class="fas fa-check"></i> Student/Member ID </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Campus"> <i v-show="mand_campus" class="fas fa-check"></i> Campus </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="CNIC no."> <i v-show="mand_cnicno" class="fas fa-check"></i> CNIC no. </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Mobile Number"> <i v-show="mand_mobilenumber" class="fas fa-check"></i> Mobile Number </span> </div>
                                        <div class="mandatory-field-col"> <span class="map-value" title="Email Address"> <i v-show="mand_emailaddress" class="fas fa-check"></i> Email Address </span> </div>
                                    </div>
                                </div>
                            </div>
                            <label for="" class="label block-label upload-label"> Preview and map your identifiers <i class="fas fa-question-circle" data-toggle="tooltip" data-placement="top" title="Please review the below identifiers in line with the columns in your sheet."></i>
                            </label>
                            <p> Please check if we have correctly picked your data. </p>
                            <div class="fields-mapping mt-4" id="fieldmapping_table">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-if="viewPage == null">
            <preLoader></preLoader>
        </template>
        <template v-if="viewPage == false">
            <notAllowed></notAllowed>
        </template>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                viewPage : true,
                previewMapField : false,
                fileAdded : false,
                fileRowData : [],
                campusCount : 0,
                campusMapped : 0,
                campusLi : [],
                finalCampusArray : [],
                dropZoneObject : null,
                mand_name : false,
                mand_studentid : false,
                mand_campus : false,
                mand_cnicno : false,
                mand_mobilenumber : false,
                mand_emailaddress : false,
                proceedButtonflag : false,
                batchSummary : [],
                discrepantStudents : {},
                inserted : null,
                discrepants : null,
            }
        },
        methods: {
            processDropzoneQueue(){

            },
            getBulkUploadStudentsData(){
                var that = this;
                this.$Progress.start();
                axios.get('/api/getFeeBulkUploadStudentsData')
                .then(response => {
                    if(response.status == 200){
                        response.data.campuses.forEach(campus => {
                            that.campusLi.push({value:campus.id,label:campus.name});
                        });
                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        this.showAlertBox('error','Error to load form data');
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    this.showAlertBox('error','Error to load form data');
                });
            },
            handleGeneratePayrollButton(){
                if(this.fileAdded == true){
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').removeAttr('disabled','disabled').addClass('active');
                    if(this.isAPIAvailable()){
                        $.when(this.printTable(this.dropZoneObject.files[0]));
                    }
                }else{
                    $('a#payroll_proceed_top,a#payroll_proceed_bottom').attr('disabled','disabled').removeClass('active');
                }
            },
            csvExport() {
            let that = this;
            let csvContent = "data:text/csv;charset=utf-8,";
            csvContent += [
                [
                'Name',
                'Student id',
                'Campus',
                'CNIC no',
                'mobile number',
                'email address'
                ],
                ...that.discrepantStudents.map(item => item)
            ]
                .join("\n")
                .replace(/(^\[)|(\]$)/gm, "");
            const data = encodeURI(csvContent);
            const link = document.createElement("a");
            link.setAttribute("href", data);
            link.setAttribute("download", "Descrepant Students.csv");
            link.click();
            },
            proceedToShops(){
                $('#batchSummary').modal('hide');
                this.$router.push('/feeStudents');
            },
            initDropZone() {
                var that = this;
                Dropzone.options.drop = {
                    addRemoveLinks: true,
                    paramName: 'file',
                    maxFilesize: 2, // MB
                    uploadMultiple: false,
                    maxFiles: 1,
                    minFiles: 1,
                    queueLimit:1,
                    url: that.$global.base_url+'api/feeStudentsBulkUploadFile',
                    acceptedFiles: '.csv',
                    autoProcessQueue:false,
                    headers: window.axios.defaults.headers.common,
                    init: function(){
                        var _this = this;
                        that.dropZoneObject = this;
                        var selectedFile = document.getElementById('selectFromComputer');
                        selectedFile.addEventListener('click',function(){
                            _this.hiddenFileInput.click();
                        });
                        this.on("maxfilesexceeded", function(file) {
                            this.removeAllFiles();
                            this.addFile(file);
                        });
                        this.on('removedfile',function(file){
                            that.fileAdded = false;
                            $('div.box__input').show();
                        }),
                        this.on("addedfile", function(file) {
                            that.fileAdded = true;
                            that.checkFileForErrors(file);
                            that.handleGeneratePayrollButton();
                        });
                        var submitButton_top 	= document.querySelector("#process_dropzone_queue");
                        var popupProcessButton 	= document.querySelector("#popupProcessButton");
                        function processFileLocal(){
                            if(that.isAPIAvailable()){
                                $.when(that.printTable(that.dropZoneObject.files[0]));
                            }
                        }
                        function processQueueLocal(){
                            $('div.progress').addClass('step-three').removeClass('step-two');
                            if(
                                (that.campusCount > 0 && that.campusCount != that.campusMapped) //Campus Count
                            ){
                                if($("#needAttention").hasClass('show')){
                                    that.showToastBox('error','Please either add them or associate them with exisiting ones.');
                                }else{
                                    $("#needAttention").modal("show");
                                }
                            }else{
                                that.dropZoneObject.processQueue(); // Tell Dropzone to process all queued files.
                            }
                        }
                        submitButton_top.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        popupProcessButton.addEventListener("click", function(e) {
                            processQueueLocal();
                        });
                        that.dropZoneObject.on("sending", function(file, xhr, formData) {
                            that.$Progress.start();
                            var campusNames = [];
                            var campusids = [];
                            that.finalCampusArray.forEach(campus => {
                                campusNames.push(campus.name);
                                campusids.push(campus.id);
                            });
                            // Will send the filesize along with the file as POST data.
                            formData.append("campusNames", JSON.stringify(campusNames));
                            formData.append("campusids", JSON.stringify(campusids));
                            formData.append("filesize", file.size);
                            var mapIdentifier = [];
                            var selVal = '';
                            $( "select.selectpicker" ).each(function() {
                                selVal = $(this).find('option:selected').val();
                                mapIdentifier.push(selVal);
                                selVal = '';
                            });
                            formData.append("mapIdentifier", JSON.stringify(mapIdentifier));
                            formData.append("_token",$('meta[name="csrf-token"]').attr('content'));
                        });

                        that.dropZoneObject.on("totaluploadprogress", function(progress) {

                        });

                        that.dropZoneObject.on("uploadprogress", function(file, progress, bytesSent) {
                            // Update progress bar with the value in the variable "progress", which
                            // is the % total upload progress from 0 to 100
                            var progressBar = Math.floor(progress);
                            if(progressBar == 100){
                                that.$Progress.finish();
                            }
                        });

                        that.dropZoneObject.on("success", function(file, obj) {
                            if(obj.code == "200") {
                                $("#needAttention").modal("hide");
                                that.showToastBox('success','File has been uploaded');
                                that.batchSummary = obj.data;

                                that.inserted = obj.data.inserted;
                                that.discrepants = obj.data.discrepants;
                                $('#inserted_rows').html(that.inserted);
                                $('#discrepant_rows').html(that.discrepants);

                                that.discrepantStudents = obj.discrepantStudents;
                                $('#batchSummary').modal('show');
                            }else{
                                that.showAlertBox('error','Error in file',msg);
                            }
                        });
                        that.dropZoneObject.on('error',function(file,errorMessage,xhr){
                            if(!file.accepted){
                                fileAdded = false;
                                that.showAlertBox('error','Error in file');
                                this.removeFile(file);
                            }
                            var msg = 'Error:'+xhr.status+' '+xhr.statusText;
                            that.showAlertBox('error','Error in file', msg);
                            file.status = Dropzone.QUEUED;
                        });
                    }
                };
                $('.cross').on('click', function(e){
                    that.dropZoneObject.removeAllFiles();
                    $('label.uploadedFileName').html('Drop your file here');
                });
            },
            isAPIAvailable() {
                // Check for the various File API support.
                if (window.File && window.FileReader && window.FileList && window.Blob) {
                    // Great success! All the File APIs are supported.
                    return true;
                } else {
                    var error_message = 'The HTML5 APIs used in this form are only available in the following browsers:<br /> - Google Chrome: 13.0 or later<br /> - Mozilla Firefox: 6.0 or later<br /> - Internet Explorer: Not supported (partial support expected in 10.0)<br /> - Safari: Not supported<br /> - Opera: Not supported';
                    this.showAlertBox('error',error_message);
                    return false;
                }
            },
            printTable(file) {
                var campusRowid = 0;
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    for(var row in data){
                        if(row > 0){
                            var _row = [];
                            for(var item in data[row]){
                                var value = data[row][item];
                                _row.push(value);
                            }
                            that.fileRowData.push(_row);
                        }
                    }
                    var test 		= '';
                    var selected 	= '';
                    var col = [];
                    for(var row in data) {
                        if(row > 1) break;
                        for(var item in data[row]) {
                            if(row == 0){
                                col[item] = [data[row][item]];
                            }else{
                                col[item].push(data[row][item]);
                            }
                        }
                    }
                    for(var row1 in col) {
                        var rowName = '';
                        var rowValue = '';
                        var comboBox = '';
                        var fieldMap = false;
                        for(var item1 in col[row1]) {
                            if(item1 > 1){ break; }
                            if(item1 == 0){
                                rowName = col[row1][item1];
                            }else{
                                rowValue += '<p>' + col[row1][item1] + '</p>';
                            }
                        }
                        // check for if you find the Name in you ddList
                        if(rowName.trim().toLocaleLowerCase() == 'name'){
                            that.mand_name = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'student id'){
                            that.mand_studentid = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'campus'){
                            that.mand_campus = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'cnic no'){
                            that.mand_cnicno = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'mobile number'){
                            that.mand_mobilenumber = fieldMap = true;
                        }
                        if(rowName.trim().toLocaleLowerCase() == 'email address'){
                            that.mand_emailaddress = fieldMap = true;
                        }
                        comboBox += '<select name="'+row1+'" class="selectpicker show-menu-arrow custom-select2" data-size="5">';
                        comboBox += '<option value="do-not"> - Select - </option>';
                        comboBox += '<optgroup label="Student Detail">';
                        selected = (rowName.trim().toLocaleLowerCase() == 'name') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'name') ? true : fieldMap;
                        comboBox += '<option value="Name" '+selected+'>Name</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'student id') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'student id') ? true : fieldMap;
                        comboBox += '<option value="Student Id" '+selected+'>Student/Member Id</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'campus') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'campus') ? true : fieldMap;
                        comboBox += '<option value="Campus" '+selected+'>Campus/Branch</option>';
                        if(selected == 'selected'){
                            campusRowid = row1;
                        }
                        selected = (rowName.trim().toLocaleLowerCase() == 'cnic no') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'cnic no') ? true : fieldMap;
                        comboBox += '<option value="CNIC no." '+selected+'> CNIC no.</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'mobile number') ? true : fieldMap;
                        comboBox += '<option value="Mobile Number" '+selected+'> Mobile Number</option>';
                        selected = (rowName.trim().toLocaleLowerCase() == 'email address') ? 'selected' : '';
                        fieldMap = (rowName.trim().toLocaleLowerCase() == 'email address') ? true : fieldMap;
                        comboBox += '<option value="Email Address" '+selected+'> Email Address</option>';
                        comboBox += '</select>';
                        if(fieldMap == true){
                            test += '<div class="row mapped align-items-center">';
                        }else{
                            test += '<div class="row align-items-center">';
                        }
                        test += '<div class="col-md-1"><div class="fields-mapping-inner"><i class="fas fa-check-circle"></i></div></div>';
                        test += '<div class="col-md-7"><div class="fields-mapping-inner"><p> '+rowName+' </p><p> '+rowValue+' </p></div></div>';
                        test += '<div class="col-md-4"><div class="fields-mapping-inner">';
                        test += comboBox;
                        test += '</div></div>';
                        test += '</div>';
                    }
                    $('#fieldmapping_table').html(test);
                    that.previewMapField = true;
                    that.generateButtonProccess();
                    $('select.selectpicker').selectpicker('refresh');
                    that.assignComboFunction();
                    if(campusRowid != 0){
                        that.showFieldInIdentifiers('campus',that.fileRowData,campusRowid);
                    }
                    $('div.progress').addClass('step-two');
                };
                reader.onerror = function(){ this.showAlertBox('error','Unable to read ' + file.fileName); }.bind(this);
            },
            generateButtonProccess(){
                if(this.mand_name == true && this.mand_studentid == true && this.mand_campus == true && this.mand_cnicno == true && this.mand_mobilenumber == true && this.mand_emailaddress == true){
                    this.proceedButtonflag = true;
                }else{
                    this.proceedButtonflag = false;
                }
            },
            checkForMandField(){
                $( "select.selectpicker" ).each(function() {
                    this.mand_name = this.mand_studentid = this.mand_campus = this.mand_cnicno = this.mand_mobilenumber = this.mand_emailaddress = false;
                    var selVal = $(this).find('option:selected').val();
                    if(selVal.trim().toLowerCase() == 'name') this.mand_name = true;
                    if(selVal.trim().toLowerCase() == 'student id') this.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'campus') this.mand_campus = true;
                    if(selVal.trim().toLowerCase() == 'cnic no.') this.mand_cnicno = true;
                    if(selVal.trim().toLowerCase() == 'mobile number') this.mand_mobilenumber = true;
                    if(selVal.trim().toLowerCase() == 'emailaddress') this.mand_emailaddress = true;
                });
            },
            assignComboFunction(){
                var that = this;
                // Auto Mapped value make disabled
                $('select.selectpicker').each(function(index,obj){
                    $('select.selectpicker option[value="'+obj.value+'"]').attr('disabled',true);
                });
                $(that.$el).find('.selectpicker').selectpicker('refresh');
                var previous;
                $('select.selectpicker').on('shown.bs.select',function(){
                    previous = this.value;
                }).change(function(){
                    var selVal = $(this).find('option:selected').val();
                    $('select.selectpicker option[value="'+previous+'"]').attr('disabled',false);
                    //hide the department, branch and city field sets if deselect
                    if(previous.toLowerCase() == 'campus'){
                        $('div.campusTable').remove();
                        $('table.campusTable').remove();
                    }
                    $('select.selectpicker option[value="'+selVal+'"]').attr('disabled',true);
                    $(that.$el).find('.selectpicker').selectpicker('refresh');

                    var flag = false;
                    that.checkForMandField();
                    if(selVal.trim().toLowerCase() == 'name') that.mand_name = true;
                    if(selVal.trim().toLowerCase() == 'student id') that.mand_studentid = true;
                    if(selVal.trim().toLowerCase() == 'campus'){
                        that.mand_campus = true;
                        that.campusMapped = that.campusCount = 0;
                        that.finalCampusArray = [];
                        that.showFieldInIdentifiers('campus',that.fileRowData,$(this).attr('name'));
                    }
                    if(selVal.trim().toLowerCase() == 'cnic no.') that.mand_cnicno = true;
                    if(selVal.trim().toLowerCase() == 'mobile number') that.mand_mobilenumber = true;
                    if(selVal.trim().toLowerCase() == 'email address') that.mand_emailaddress = true;

                    that.generateButtonProccess();
                });
            },
            showFieldInIdentifiers(datafor,fileRowData,itemIndex){
                var dataTableFor = '';
                var mappingfor = '';
                if(datafor == 'campus'){
                    mappingfor = '<h3>We\'ve found some new campus.</h3><p class="mb-2"> Please either add them below or associate them with existing ones. </p>';
                    dataTableFor = 'campusTable';
                }
                var html = mappingfor;
                if(datafor == 'campus'){
                    var campusArray = [];
                    for(var k =0; k < fileRowData.length; k++){
                        var data = fileRowData[k];
                        var campus = data[itemIndex];
                        if(campusArray.indexOf(campus) == -1){
                            campusArray.push(campus);
                        }
                    }
                    this.campusCount = campusArray.length;
                    for(var k = 0; k < this.campusCount; k++){
                        var li = '';
                        var match = false;
                        var selected = '';
                        var defaultCampus = 'Select Campus';
                        for(var t=0; t < this.campusLi.length; t++){
                            if(this.campusLi[t].label.toLowerCase() == campusArray[k].toLowerCase()){
                                match = true;
                                selected = 'row-enabled';
                                this.defaultCampus = this.campusLi[t].label;
                                this.finalCampusArray.push({id:this.campusLi[t].value,name:campusArray[k]});
                                this.campusMapped = this.finalCampusArray.length;
                            }else{
                                selected = '';
                            }
                            li += '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCampusSelection(\''+this.campusLi[t].value+'\',\''+campusArray[k]+'\',this);">'+this.campusLi[t].label+'</a></li>';
                        }
                        html += '<div class="row mt-2 align-items-center">';
                            html += '<div class="col-md-8">';
                                html += '<strong class="title">'+campusArray[k]+'</strong>';
                            html += '</div>';
                            html += '<div class="col-md-4">';
                                html += '<div class="dropdown">';
                                    html += '<a class="form-control drop-value-changer" data-toggle="dropdown" href="javascript:void(0);">Select Campus<span class="caret"></span></a>';
                                    html += '<div class="dropdown-menu add-category-dropdown">';
                                        html += '<ul class="campus_list list">';
                                        html += li;
                                        html += '</ul>';
                                        html += '<div class="add-category"><button class="dropdown-link btn btn-primary" data-toggle="modal" data-target="#addCategory"><i class="fas fa-plus"></i> Add Campus</button></div>';
                                    html += '</div>';
                                html += '</div>';
                            html += '</div>';
                        html += '</div>';
                    }
                }
                $('div.need-attention-content').append(html);
                this.customCombo();
            },
            customCombo(){
                // for c-val-displayer start
                $(".cstm-cmbx-w-adtn .c-val-displayer").unbind('click').click(function(){
                    var ref = $(this);
                    var popDiv =  $(this).parent().find(".val-overlyr");
                    var popper = new Popper(ref,popDiv,{
                        placement:'bottom-end',
                        gpuAcceleration:false
                    });
                    $(this).parent().find(".val-overlyr").toggleClass("activated");
                });
                // for c-val-displayer end
            },
            checkFileForErrors(file){
                var reader = new FileReader();
                reader.readAsText(file);
                var that = this;
                reader.onload = function(event){
                    var csv = event.target.result;
                    var data = $.csv.toArrays(csv);
                    var col = [];
                    var duplicate = false;
                    var column = false;
                    var duplicateArray = [];
                    for(var row in data) {
                        if(row == 0){
                            for(var item in data[row]) {
                                var value = data[row][item];
                                value = value.replace(/[^\w\s]/gi,'');
                                if(col.indexOf(value) > -1){
                                    duplicate = true;
                                    duplicateArray.push(value);
                                }
                                col.push(value);
                            }
                        }else{
                            break;
                        }
                    }
                    if(duplicate == true && that.fileAdded == true){
                        var error_message = $('div#duplicatemessage').html() + duplicateArray.toString();
                        that.showAlertBox('error','Duplicate column name',error_message);
                    }
                    if(col.length < 3 && that.fileAdded == true){
                        column = true;
                        var error_message = $('div#columnfourmessage').html();
                        that.showAlertBox('error','Missing column',error_message);
                    }
                    if(duplicate == true || column == true){
                        that.dropZoneObject.removeAllFiles();
                    }
                };
                reader.onerror = function(){ this.showAlertBox('Unable to read ' + file.fileName); }.bind(this);
            },
            saveCampus(){
                var campusValue = $('#campusAddValue').val();
                if (campusValue === "") {
                    that.showAlertBox('error','Please enter campus name');
                }else{
                    var that = this;
                    this.$Progress.start();
                    axios.post('/api/addCampus',{name:campusValue})
                    .then(response => {
                        if(response.status == 200){
                            that.finalCampusArray.push({id:response.data.campus_id,name:campusValue});
                            that.campusMapped = that.finalCampusArray.length;
                            var html = '<li class="catory-value"><a class="dropdown-link" href="javascript:void(0)" onclick="mapCampusSelection(\''+response.data.campus_id+'\',\''+campusValue+'\',this);">'+campusValue+'</a></li>';
                            $('ul.campus_list').find('li:last').each(function(){
                                $(this).after(html);
                            });
                            $("#addCategory").modal("hide");
                            that.showToastBox('success','Campus has been added');
                            that.$Progress.finsih();
                        }else{
                            that.showAlertBox('error','Something went wrong');
                            that.$Progress.fail();
                        }
                    });
                }
            }

        },
        created() {
        },
        mounted(){
            var that = this;
            this.getBulkUploadStudentsData();
            if(this.viewPage == true){
                this.initDropZone();
                $(".drozone-label").tooltip({
                    html	: true,
                    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner large"></div></div>',
                });
                $("#drop").dropzone();
                $(window.document).on('show.bs.modal', '.modal', function (event) {
                    var zIndex = 1040 + (10 * $('.modal:visible').length);
                    $(this).css('z-index', zIndex);
                    setTimeout(function() {
                        $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
                    }, 0);
                });
                window.mapCampusSelection = function(id,value,obj){
                    $(obj).parent().find("li").removeClass("row-enabled");
                    $(obj).addClass('row-enabled');
                    var valueExist = false;
                    for(var index in that.finalCampusArray){
                        if(that.finalCampusArray[index].name.toLowerCase() == value.toLowerCase()){
                            that.finalCampusArray.splice(index,1);
                            that.finalCampusArray.push({id:id,name:value});
                            valueExist = true;
                            break;
                        }
                    }
                    if(valueExist === false){
                        that.finalCampusArray.push({id:id,name:value});
                    }
                    that.campusMapped = that.finalCampusArray.length;
                    that.generateButtonProccess();
                }
            }
        }
    }
</script>
